import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import { ZIndex, AnalyticsId } from "../../constants.js";
import { u as uuid } from "../../uuid.js";
import loaderStyles from "./styles.module.scss";
var Overlay = /* @__PURE__ */ ((Overlay2) => {
  Overlay2["screen"] = "screen";
  Overlay2["parent"] = "parent";
  return Overlay2;
})(Overlay || {});
const Loader = (props) => {
  const {
    overlay,
    size = "small",
    className = "",
    labelId = uuid(),
    testId,
    center,
    inline,
    ariaLabelledById,
    ariaLabel = "Laster inn"
  } = props;
  const color = props.overlay ? "white" : props.color || "neutral";
  const showLoader = () => {
    if (overlay === "parent" || inline) {
      return false;
    }
    return true;
  };
  const [display, setDisplay] = useState(showLoader());
  const isSmall = size === "small";
  const isMedium = size === "medium";
  const isLarge = size === "large";
  const loaderWrapperClasses = classNames({
    [loaderStyles["loader-wrapper--center"]]: center,
    [loaderStyles["loader-wrapper--overlay"]]: overlay,
    [loaderStyles["loader-wrapper--overlay-screen"]]: overlay === "screen",
    [loaderStyles["loader-wrapper--overlay-parent"]]: overlay === "parent" && display,
    [loaderStyles["loader-wrapper--inline"]]: inline && display
  });
  const loaderClasses = classNames(
    loaderStyles.loader,
    {
      [loaderStyles["loader--small"]]: isSmall,
      [loaderStyles["loader--medium"]]: isMedium,
      [loaderStyles["loader--large"]]: isLarge
    },
    className
  );
  const loaderDotClasses = classNames(loaderStyles.loader__dot, {
    [loaderStyles["loader__dot--small"]]: isSmall,
    [loaderStyles["loader__dot--medium"]]: isMedium,
    [loaderStyles["loader__dot--large"]]: isLarge,
    [loaderStyles["loader__dot--banana"]]: color === "banana",
    [loaderStyles["loader__dot--cherry"]]: color === "cherry",
    [loaderStyles["loader__dot--kiwi"]]: color === "kiwi",
    [loaderStyles["loader__dot--neutral"]]: color === "neutral",
    [loaderStyles["loader__dot--plum"]]: color === "plum",
    [loaderStyles["loader__dot--black"]]: color === "black",
    [loaderStyles["loader__dot--white"]]: color === "white"
  });
  const wrapperRef = useRef(null);
  useEffect(() => {
    var _a, _b, _c, _d;
    if (overlay === "parent" && ((_b = (_a = wrapperRef.current) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.style)) {
      wrapperRef.current.parentElement.style.position = "relative";
      setDisplay(true);
    }
    if (inline && ((_d = (_c = wrapperRef.current) == null ? void 0 : _c.parentElement) == null ? void 0 : _d.style)) {
      wrapperRef.current.parentElement.style.display = "flex";
      setDisplay(true);
    }
  }, []);
  return /* @__PURE__ */ jsx("div", { className: loaderWrapperClasses, ref: wrapperRef, style: overlay === "screen" ? { zIndex: ZIndex.OverlayScreen } : {}, children: display && /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": testId,
      "data-analyticsid": AnalyticsId.Loader,
      role: "progressbar",
      "aria-labelledby": ariaLabelledById || labelId,
      className: loaderClasses,
      children: [
        /* @__PURE__ */ jsx("div", { className: loaderDotClasses }),
        /* @__PURE__ */ jsx("div", { className: loaderDotClasses }),
        /* @__PURE__ */ jsx("div", { className: loaderDotClasses }),
        /* @__PURE__ */ jsx("div", { className: loaderDotClasses }),
        !ariaLabelledById && /* @__PURE__ */ jsx("span", { id: labelId, className: loaderStyles["loader__hidden-text"], children: ariaLabel })
      ]
    }
  ) });
};
export {
  Overlay,
  Loader as default
};
//# sourceMappingURL=index.js.map
